export function chooseSubscriptionPlanId(plans = [], subscription = null, currentPlanId = "") {
  const available = Array.isArray(plans) ? plans : [];
  if (currentPlanId && available.some((plan) => plan.id === currentPlanId)) {
    return currentPlanId;
  }

  const subscribedPlanId = subscription?.plan?.id || "";
  if (subscribedPlanId && available.some((plan) => plan.id === subscribedPlanId)) {
    return subscribedPlanId;
  }

  return available[0]?.id || "";
}

const BLOCKED_ACCESS_STATUSES = new Set(["expired", "requires_payment", "revoked"]);
const BLOCKED_SUBSCRIPTION_STATUSES = new Set(["expired", "revoked"]);

export function isSubscriptionReadOnly(subscription) {
  if (!subscription) return false;

  const accessStatus = String(subscription.accessStatus || "").trim().toLowerCase();
  const status = String(subscription.status || "").trim().toLowerCase();

  return (
    subscription.canUseApp === false ||
    BLOCKED_ACCESS_STATUSES.has(accessStatus) ||
    BLOCKED_SUBSCRIPTION_STATUSES.has(status)
  );
}

export const requiresSubscriptionRenewal = isSubscriptionReadOnly;

export function resolveSubscriptionPaymentReference(searchParams, storedReference = "") {
  return String(
	searchParams?.get?.("transaction_ref") ||
	searchParams?.get?.("reference") ||
    searchParams?.get?.("trxref") ||
    storedReference ||
    "",
  ).trim();
}

export function readSessionStorageValue(key) {
  try {
    return window.sessionStorage.getItem(key) || "";
  } catch {
    return "";
  }
}

export function writeSessionStorageValue(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // Checkout can continue even when browser storage is unavailable.
  }
}

export function removeSessionStorageValue(key) {
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // The verified server state remains authoritative.
  }
}
